import * as React from 'react';
import { translate } from 'components/translate-hoc';

// types
import { IProfilePlatform } from 'types/profiles';
import { ITranslationProps } from 'types/translation';

// constants
import { TEXT_KEYS } from './redemption-main-error.constants';
import { PLATFORM_DISPLAY_PROPS } from 'constants/platforms-display-props';

// styles
import './redemption-main-error.styles.less';

export class RedemptionMainError extends React.Component<IRedemptionMainTranslateProps> {
    public getError(): JSX.Element | null {
        const { activeProfilePlatform } = this.props;
        if (!activeProfilePlatform) {
            return this.getErrorFromTextKey(TEXT_KEYS.REDEEM_MAIN_PAGE_ERROR);
        }

        const wasLinked: boolean = !!activeProfilePlatform.profileId;
        const isLinkable: boolean = PLATFORM_DISPLAY_PROPS[activeProfilePlatform.id].isLinkable;

        if (!wasLinked && isLinkable) {
            return this.getErrorFromTextKey(TEXT_KEYS.REDEEM_MAIN_PAGE_LINKING_ERROR);
        }

        if (!this.props.isCodeValid) {
            return this.getErrorFromTextKey(TEXT_KEYS.REDEEM_CODE_ERROR);
        }

        return null;
    }

    public getErrorFromTextKey(key: string): JSX.Element {
        const { dangerouslyTranslateWithHTML: translateKey } = this.props;
        const errorText: string = translateKey(key);
        return <div className="sitegen-redemption__error">{errorText}</div>;
    }

    public render(): JSX.Element | null {
        return (this.props.showError) ? this.getError() : null;
    }
}

export interface IRedemptionMainErrorProps {
    readonly showError: boolean;
    readonly activeProfilePlatform: IProfilePlatform | null;
    readonly isCodeValid: boolean;
}

export type IRedemptionMainTranslateProps = IRedemptionMainErrorProps & ITranslationProps;

export default translate()(RedemptionMainError) as React.ComponentClass<IRedemptionMainErrorProps>;
